import { useState, useEffect } from "react";
import "./street.css";

const API = process.env.REACT_APP_API_URL;

const a = [
  "Center", "Arabkir", "Davtashen", "Ajapnyak", "VahagniDistrict",
  "KanakerZeytun", "Avan", "NorNorq", "NorkMarash", "Shengavit",
  "MalatiaSebastia", "Erebuni",
  "Jrvej", "Zovuni", "Dzoraghpyur", "Ptghni", "Arzni", "Qasakh", "NorGeghi",
  "NorHajn", "Tsakhkadzor", "Abovyan", "Proshyan", "Arinj",
  "Byureghavan", "Yeghvard",
  "Dilijan",
];

const LABELS = {
  Center: "ԿԵՆՏՐՈՆ",
  Arabkir: "ԱՐԱԲԿԻՐ",
  Davtashen: "ԴԱՎԹԱՇԵՆ",
  Ajapnyak: "ԱՋԱՓՆՅԱԿ",
  VahagniDistrict: "ՎԱՀԱԳՆԻ",
  KanakerZeytun: "ՔԱՆԱՔԵՌ-ԶԵՅԹՈՒՆ",
  Avan: "ԱՎԱՆ",
  NorNorq: "ՆՈՐ ՆՈՐՔ",
  NorkMarash: "ՆՈՐՔ-ՄԱՐԱՇ",
  Shengavit: "ՇԵՆԳԱՎԻԹ",
  MalatiaSebastia: "ՄԱԼԱԹԻԱ-ՍԵԲԱՍՏԻԱ",
  Erebuni: "ԷՐԵԲՈՒՆԻ",
  Jrvej: "ՋՐՎԵԺ",
  Zovuni: "ԶՈՎՈՒՆԻ",
  Dzoraghpyur: "ՁՈՐԱՂԲՅՈՒՐ",
  Ptghni: "ՊՏՂՆԻ",
  Arzni: "ԱՐԶՆԻ",
  Qasakh: "ՔԱՍԱԽ",
  NorGeghi: "ՆՈՐ ԳԵՂԻ",
  NorHajn: "ՆՈՐ ՀԱՃՆ",
  Tsakhkadzor: "ԾԱՂԿԱՁՈՐ",
  Abovyan: "ԱԲՈՎՅԱՆ",
  Proshyan: "ՊՌՈՇՅԱՆ",
  Arinj: "ԱՌԻՆՋ",
  Byureghavan: "ԲՅՈՒՐԵՂԱՎԱՆ",
  Yeghvard: "ԵՂՎԱՐԴ",
  Dilijan: "ԴԻԼԻՋԱՆ",
};

const GROUPS = [
  a.slice(0, 12),  // ԵՐԵՎԱՆ
  a.slice(12, 26), // ԿՈՏԱՅՔ (с Арзни)
  a.slice(26),     // ՏԱՎՈՒՇ
];

function toIndexes(value) {
  const list = Array.isArray(value) ? value : [value];
  return list
    .map((v) => (v === null || v === undefined || v === "" ? NaN : Number(v)))
    .filter((n) => Number.isInteger(n) && n >= 0);
}

function getActiveKeys(district, district1, district2) {
  const keys = [district, district1, district2]
    .flatMap((value, g) => toIndexes(value).map((i) => GROUPS[g][i]))
    .filter(Boolean);
  return keys.length > 0 ? keys : a;
}

export default function Street({ district, district1, district2, editData, errors }) {
  const [query, setQuery] = useState("");
  const [selected, setSelected] = useState("");
  const [filtered, setFiltered] = useState({});
  const [streetLanguage, setStreetLanguage] = useState({});
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    fetch(`${API}/streets`)
      .then((res) => res.json())
      .then((data) => setStreetLanguage(data))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (editData?.street) {
      setQuery(editData.street);
      setSelected(editData.street);
    }
  }, [editData]);

  // при смене района выбранная улица сбрасывается
  useEffect(() => {
    if (!editData?.street) {
      setSelected("");
      setQuery("");
      setFiltered({});
    }
  }, [district, district1, district2]);

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    setSelected(""); // любое изменение текста отменяет выбор

    if (!value) {
      setFiltered({});
      return;
    }

    const streetsByLang = streetLanguage["armenian"];
    if (!Array.isArray(streetsByLang)) return;

    const resultObj = {};
    streetsByLang.forEach((streetsInDistrict, i) => {
      if (!Array.isArray(streetsInDistrict)) return;
      const matches = streetsInDistrict.filter((street) =>
        street?.toLowerCase().includes(value.toLowerCase())
      );
      if (matches.length > 0) resultObj[a[i]] = matches;
    });

    setFiltered(resultObj);
  };

  const selectStreet = (street) => {
    setQuery(street);
    setSelected(street);
    setFiltered({});
  };

  const handleBlur = () => {
    setTouched(true);
    setFiltered({});
  };

  const activeKeys = getActiveKeys(district, district1, district2);
  const items = activeKeys.flatMap((key) =>
    (filtered[key] || []).map((street) => ({ key, street }))
  );

  const notSelected = touched && query !== "" && !selected;
  const hasError = errors?.street || notSelected;

  return (
    <div className="street">
      <input
        type="text"
        autoComplete="off"
        value={query}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="ՓՈՂՈՑ"
        style={{
          borderRadius: "10px",
          border: hasError ? "2px solid red" : "1px solid #ccc",
        }}
      />

      {/* в форму уходит только улица, выбранная из списка */}
      <input type="hidden" name="street" value={selected} />

      {notSelected && (
        <p style={{ color: "red", fontSize: "13px", margin: "4px 0 0" }}>
          Ընտրեք փողոցը ցուցակից
        </p>
      )}

      {items.length > 0 && (
        <div className="filteredStreet">
          {items.map(({ key, street }) => (
            <p
              key={`${key}-${street}`}
              style={{ padding: "2px", cursor: "pointer" }}
              onMouseDown={(e) => {
                e.preventDefault(); // чтобы blur не закрыл список раньше клика
                selectStreet(street);
              }}
            >
              {street}
              <span> {LABELS[key]}</span>
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
